<div class="position-relative h-100" *ngIf="!isEditing">
    <cv-loader *ngIf="isLoading" [overlay]="true"></cv-loader>
    <div class="container overflow-hidden h-100 d-flex flex-column">
        <div class="d-flex my-4 align-items-center">
            <button type="button" class="btn btn-primary btn-icon" (click)="createNewDefinition()" [disabled]="isLoading || isBlocked">
                <svg><use href="../App_Themes/clearview-default/icons/utility/add.svg#add"></use></svg>
                <span cvLocalizedText langSection="Pipeline_Configuration" langKey="Add_New">Add New</span>
            </button>
        </div>
        <div class="row pb-3" style="flex: 1 1 0px; min-height: 0px;">
            <div class="col-3 h-100">
                <div class="content h-100 d-flex flex-column">
                    <div>
                        <div class="px-4 py-2 pipelineMetricDefinitionsHeader">
                            <span cvLocalizedText langSection="Pipeline_Configuration" langKey="Categories">Categories</span>
                        </div>
                    </div>
                    <div class="overflow-auto" style="flex: 1 1 0px; min-height: 0px;">
                        <div class="scrollable px-4 py-2">
                            <div class="txtOverflow pipelineMetricSelectorCategory mb-3"
                                *ngFor="let groupedDefs of (filteredDefinitions | categorizeMetricDefinitions)" [title]="groupedDefs[0]"
                                (click)="scrollCategoryIntoView(groupedDefs[0])">
                                {{groupedDefs[0]}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-5 h-100">
                <div class="content h-100 d-flex flex-column">
                    <div>
                        <div class="px-4 py-2 pipelineMetricDefinitionsHeader">
                            <span cvLocalizedText langSection="Pipeline_Configuration" langKey="Metrics">Metrics</span>
                        </div>
                    </div>
                    <div>
                        <div class="px-4 py-2" style="width: 60%">
                            <div class="search-box live-search">
                                <input type="search" class="form-control" 
                                [(ngModel)]="filterValue"
                                (ngModelChangeDebounced)="applyFilter()"
                                [ngModelChangeDebounceTime]="150"
                                ng-trim="true"
                                placeholder="Search..."
                                cvLocalizedAttrs="placeholder"
                                attrLangSection="Subscriptions_Management"
                                attrLangKey="Search">
                                <span class="clear-input" (click)="clearFilter()" [hidden]="filterValue == ''"></span>
                            </div>
                        </div>
                    </div>
                    <div class="overflow-auto">
                        <div class="px-4" id="metric-names">
                            <div *ngFor="let groupedDefs of (filteredDefinitions | categorizeMetricDefinitions)" [attr.data-category]="groupedDefs[0]" #metricCategory>
                                <div class="pipelineMetricSelectorSectionHeader lato-bold mt-4 color-valyrianSteel">{{groupedDefs[0]}}</div>
                                <hr>
                                <div class="d-flex flex-wrap justify-content-start align-items-center">
                                    <div class="pipelineMetricSelector w-50 my-2 d-flex align-items-center" *ngFor="let def of groupedDefs[1]" [attr.title]="def.MetricName" [ngClass]="{selectedMetric: selectedMetricDefinition === def}" (click)="selectMetricDefinition(def)">
                                        <span class="txtOverflow text-nowrap">{{def.Abreviation}}</span>
                                        <!-- "Not editable" and Status icons -->
                                        <div class="d-inline-block ml-2" *ngIf="!def.IsEditable" title="Not editable">
                                            <svg class="icon-12 fill-valyrianSteel"><use href="../App_Themes/clearview-default/icons/utility/lock.svg#lock"></use></svg>
                                        </div>
                                        <div class="d-inline-block ml-2" *ngIf="!def.Status.IsValid" title="Metric definition is invalid">
                                            <svg class="icon-12 fill-redRyder"><use href="../App_Themes/clearview-default/icons/utility/error.svg#error"></use></svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-4 h-100">
                <cv-loader *ngIf="isLoading"></cv-loader>
                <div class="content h-100 d-flex flex-column">
                    <div>
                        <div class="px-4 py-2 pipelineMetricDefinitionsHeader d-flex justify-content-between">
                            <div class="d-flex">
                                <span cvLocalizedText langSection="Pipeline_Configuration" langKey="Properties">Properties</span>
                                <div title="Not editable" *ngIf="selectedMetricDefinition && !selectedMetricDefinition.IsEditable" class="ml-1" style="height: 16px; width: 16px; margin-top: -2px;">
                                    <svg class="icon-16 fill-valyrianSteel"><use href="../App_Themes/clearview-default/icons/utility/lock.svg#lock"></use></svg>
                                 </div>
                            </div>
                            <div *ngIf="selectedMetricDefinition">
                                <button type="button" class="icon-btn fill-valyrianSteel fill-hover-whaleTail" cvLocalizedAttrs="title" attrLangSection="Pipeline_Configuration" attrLangKey="Edit_Metric"
                                    (click)="editMetricDefinition(selectedMetricDefinition)" [disabled]="isBlocked || !isEditable(selectedMetricDefinition)" [attr.title]="!isEditable(selectedMetricDefinition) && 'Not editable' || 'Edit Metric'">
                                   <svg class="icon-16">
                                      <use href="../App_Themes/clearview-default/icons/utility/edit.svg#edit"></use>
                                   </svg>
                                </button>
                                <button type="button" class="icon-btn fill-valyrianSteel fill-hover-whaleTail" cvLocalizedAttrs="title" attrLangSection="Pipeline_Configuration" attrLangKey="Copy_Metric"
                                    (click)="copyMetricDefinition(selectedMetricDefinition)" [disabled]="isBlocked">
                                   <svg class="icon-16">
                                      <use href="../App_Themes/clearview-default/icons/utility/copy.svg#copy"></use>
                                   </svg>
                                </button>
                                <button type="button" class="icon-btn fill-valyrianSteel fill-hover-whaleTail" cvLocalizedAttrs="title" attrLangSection="Pipeline_Configuration" attrLangKey="Remove_Metric"
                                    (click)="deactivateMetricDefinition(selectedMetricDefinition)" [disabled]="isBlocked || !isEditable(selectedMetricDefinition)" [attr.title]="!isEditable(selectedMetricDefinition) && 'Not editable' || 'Deactivate'">
                                   <svg class="icon-16">
                                      <use href="../App_Themes/clearview-default/icons/utility/delete.svg#delete"></use>
                                   </svg>
                                </button>
                             </div>
                        </div>
                    </div>
                    <div class="overflow-auto" style="flex: 1 1 0px; min-height: 0px;">
                        <metric-summary class="h-100" [definition]="selectedMetricDefinition"></metric-summary>
                     </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="position-relative h-100" *ngIf="isEditing">
    <edit-metric [definition]="selectedMetricDefinition" (onCommit)="editMetricCommitted($event)" (onCancel)="editMetricCanceled()"></edit-metric>
</div>
